import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as associatePaymentReducer, REDUCER_NAME as ASSOCIATE_PAYMENT_REDUCER } from './associate-payment'
import { reducer as uploadReducer, REDUCER_NAME as UPLOAD_REDUCER } from './upload'


const reducer = combineReducers({
    [ASSOCIATE_PAYMENT_REDUCER]: associatePaymentReducer,
    [UPLOAD_REDUCER]: uploadReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/payment/state/index.js